import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { useSchedule } from "../../../../../hooks/useSchedule";
import { UpcomingAppointmentItem } from "./UpcomingAppointmentItem";

export function UpcomingAppointments() {
	const { someFirstUpcomingSchedulers } = useSchedule();
	return (
		<>
			<div className="title-container">
				<Typography className="small-title-text bold">Upcoming</Typography>
				<Link to="/training/calendar" className="black-text underline-link">
					<Typography className="normal-text">View all</Typography>
				</Link>
			</div>
			{someFirstUpcomingSchedulers.length > 0 && (
				<div className="upcoming-appointments-container item-separator-tiny">
					{someFirstUpcomingSchedulers.map((upcomingAppointment) => (
						<UpcomingAppointmentItem
							upcomingAppointment={upcomingAppointment}
							key={upcomingAppointment.id}
						/>
					))}
				</div>
			)}
			{someFirstUpcomingSchedulers.length === 0 && (
				<Typography className="normal-text" textAlign="center">
					No classes or training events yet.
				</Typography>
			)}
		</>
	);
}
